export default "__VITE_ASSET__RnLUo7Cn__"